export default "__VITE_ASSET__bJU5M88j__"